import styled from 'styled-components'

interface IProps {
  value?: string | number
  type?: 'up' | 'down'
}

const StyledContainer = styled.div`
  display: flex;
  border-radius: 4px;
  padding: 0px 8px;
  line-height: 20px;
  align-items: center;
  &::before {
    content: '';
    display: block;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    margin-right: 4px;
  }
  &.up {
    background: var(--color-primary-103);
    color: var(--color-primary-108);
    &::before {
      border-bottom: 4px solid var(--color-primary-108);
    }
  }
  &.down {
    background: var(--color-orange-102);
    color: var(--color-orange-106);
    &::before {
      border-top: 4px solid var(--color-orange-106);
    }
  }
`

const UpDownValue = (props: IProps) => {
  const { value, type } = props

  return <StyledContainer className={type}>{value}</StyledContainer>
}

export default UpDownValue
